import { VENDOR_DEFINED } from '../constants';

const getServiceDefinitionID = (service) =>
    service?.serviceDefinitionID ?? service?.serviceDefinition?.id;

/**
 * (2992) Whether the company already has a service created from this
 * available service profile.
 *
 * Vendor-defined services (Value Add and Operator Platform children) all share
 * serviceType 'VendorDefined', so they are matched on their service definition
 * instead — by ID when the dashboard payload carries one, otherwise by name.
 *
 * @param {object} serviceProfile - an entry from /ServiceProfiles/Available
 * @param {object[]} existingServices - the dashboard payload's services
 * @returns {boolean}
 */
export default function isServiceProfileAdded(
    serviceProfile,
    existingServices,
) {
    if (!serviceProfile || !existingServices?.length) return false;

    if (serviceProfile.serviceType !== VENDOR_DEFINED) {
        return existingServices.some(
            (service) => service?.serviceType === serviceProfile.serviceType,
        );
    }

    const definition = serviceProfile.serviceDefinition;
    if (!definition) return false;

    return existingServices.some((service) => {
        if (service?.serviceType !== VENDOR_DEFINED) return false;
        const serviceDefinitionID = getServiceDefinitionID(service);
        if (serviceDefinitionID) return serviceDefinitionID === definition.id;
        return Boolean(definition.name) && service?.name === definition.name;
    });
}
